import {Component, inject, input, OnInit} from '@angular/core';
import {TechnicalConclusionModalService} from "../../services/technical-conclusion-modal.service";
import {TechnicalConclusionFilesStateService} from "../../services/technical-conclusion-files-state.service";
import {LoadingService} from "../../../../../../../../core/services/loading.service";
import {TechnicalConclusionFile} from "../../types/technical-conclusion-types";
import {
  AttachProductCardFileParams,
  DeleteFileParams,
  GetFilesParams
} from "../../../../../types/product-card-files.types";
import {technicalConclusionFilesResourceType} from "../../config/technical-conclusion-config";
import {AttachFileParams} from "../../../../../../../../core/types/file.types";
import {FileCardComponent} from "../../../../../../../../shared/components/ui/file-card/file-card.component";
import {
  FileUploadCardComponent
} from "../../../../../../../../shared/components/ui/file-upload-card/file-upload-card.component";

@Component({
  selector: 'div[app-technical-conclusion-files]',
  imports: [
    FileCardComponent,
    FileUploadCardComponent
  ],
  templateUrl: './technical-conclusion-files.component.html',
  styleUrl: './technical-conclusion-files.component.scss'
})
export class TechnicalConclusionFilesComponent implements OnInit {
  technicalConclusionId =  input<number>(0);
  isEditModeActive =  input<boolean>(false);

  private technicalConclusionModalService: TechnicalConclusionModalService = inject(TechnicalConclusionModalService);
  private technicalConclusionFilesStateService: TechnicalConclusionFilesStateService = inject(TechnicalConclusionFilesStateService);
  private loadingService: LoadingService = inject(LoadingService);

  public async ngOnInit(): Promise<void> {
    await this.getFiles();
  }

  public getFilesById(): Array<TechnicalConclusionFile> {
    return this.technicalConclusionFilesStateService.getTechnicalConclusionFilesById(this.technicalConclusionId());
  }

  public async handleDelete(isImage: boolean, file: TechnicalConclusionFile):  Promise<void> {
    const deleteFileParams: DeleteFileParams = {
      path: technicalConclusionFilesResourceType.path,
      id: file.id
    };

    this.technicalConclusionModalService.deleteFile(deleteFileParams)
      .then(() => this.technicalConclusionFilesStateService.deleteFileById(file.id, this.technicalConclusionId()));
  }

  public async attachFile({ parentId, fileId }: AttachFileParams): Promise<void> {
    const attachFileParams: AttachProductCardFileParams = {
      path: technicalConclusionFilesResourceType.path,
      body: {
        fileId: fileId,
        technicalConclusionId: parentId
      }
    };

    await this.technicalConclusionModalService.attachFile<TechnicalConclusionFile>(attachFileParams)
      .then((data) => this.technicalConclusionFilesStateService.updateTechnicalConclusionFilesState(this.technicalConclusionId(), data));
  }

  private async getFiles(): Promise<void> {
    this.loadingService.setIsLoadingState(true);
    const params: GetFilesParams = {
      path: technicalConclusionFilesResourceType.path,
      params: { technicalConclusionId: this.technicalConclusionId() }
    };

    await this.technicalConclusionModalService.getFiles(params)
      .then((data) => this.technicalConclusionFilesStateService.setTechnicalConclusionFilesState(this.technicalConclusionId(), data))
      .finally(() => this.loadingService.setIsLoadingState(false));
  }
}
